import React, { useEffect, useState } from "react";
import "./documents.component.scoped.scss";
import { Box, Button, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { DocumentsService } from "../../../../services/documents.services";
import { formatDate } from "../../../../helpers";
import { icons } from "../../../../statics/icons";

const DocumentsComponent = () => {
  const { t } = useTranslation();
  const documentsService = new DocumentsService();
  const [documents, setDocuments] = useState<any>([]);

  const downloadFile = (url: string) => {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    let isMounted = true;
    const fetchDocuments = async () => {
      try {
        const response = await documentsService.list();
        if (isMounted) {
          setDocuments(response.data);
          console.log(response);
        }
      } catch (err) {
        console.error("Error fetching documents", err);
      }
    };

    fetchDocuments();

    return () => {
      isMounted = false; // cleanup when unmount
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {documents.length > 0 && (
        <Box className="mb-5">
          <Box className="mb-2">
            <Typography variant="h3">
              {t("COMPANY_RELEVANT_DOCUAMNTS")}
            </Typography>
          </Box>
          <Box className="global__box__content__body">
            {documents.map((document: any, index: number) => {
              return (
                <Box
                  className="item d-flex align-items-center justify-content-between mb-2"
                  key={index}
                >
                  <Box
                    className="d-flex align-items-center"
                    style={{ gap: "1rem" }}
                  >
                    <img src={icons.DOCUMENT} alt="DOCUMENT" />
                    <Box className="info">
                      <Box
                        className="d-flex align-items-center mb-2"
                        style={{ gap: ".5rem" }}
                      >
                        <Typography variant="h4">{document.name}</Typography>
                        <span className="date">
                          {t("UPLOADED_ON")}{" "}
                          {formatDate(document.createdAt, "DD.MM.YYYY")}
                        </span>
                      </Box>
                      <Typography
                        variant="body1"
                        className="mb-1 font-weight-light"
                      >
                        {t("UPLOADED_BY")} {document.userEmail}
                      </Typography>
                      <Typography variant="body1" className="font-weight-light">
                        {t("FILE_NAME")}: {document.file}
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="actions">
                    <Button
                      variant="contained"
                      color="secondary"
                      style={{
                        color: "#fff",
                        background: "var(--secondary)",
                        fontSize: ".9rem",
                        fontWeight: 300,
                        textTransform: "capitalize",
                      }}
                      className="mr-2"
                      size="small"
                      onClick={() => downloadFile(document.url)}
                    >
                      {t("DOWNLOAD")}
                    </Button>
                  </Box>
                </Box>
              );
            })}
            <Typography variant="body1" className="mb-1 mt-2 font-weight-light">
              {t(
                "DASHBOARD.HERE_YOU_CAN_DOWNLOAD_COMPANY_RELEVANT_AI_DOCUMENTS",
              )}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};
export default DocumentsComponent;
